export default __webpack_public_path__ + "static/media/pic4.9431085f.jpg";